// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__TAnDS","text":"SelectPayment_text__27YHh","title":"SelectPayment_title__1CTmi","btn":"SelectPayment_btn__7EhXz"};